import About from "../pages/AboutUs";
import Blog from "../pages/Blog";
import Contact from "../pages/Contact";
import Home from "../components/home/Home";
import Portfolio from "../pages/Portfolio";
import Service from "../pages/Service";

import MainLayout from "../layout/MainLayout";
import LayoutTwo from "../layout/LayoutTwo";
import { renderRoutes } from "./generateFlattenRoutes";

import App from "../pages/App";
import Software from "../pages/Software";

export const routes = [
    {
        layout: MainLayout,
        routes: [
            {
                name: 'home',
                title: 'Home page',
                component: Home,
                hasSiderLink: true,
                routes: [
                    {
                        name: 'Software-Landing',
                        title: 'Software Landing',
                        hasSiderLink: true,
                        component: Software,
                        path: '/'
                    }
                ]
            },
            {
                name: 'about',
                title: 'about page',
                component: About,
                path: '/about'
            },
            {
                name: 'service',
                title: 'service page',
                component: Service,
                path: '/service'
            }, {
                name: 'portfolio',
                title: 'portfolio page',
                component: Portfolio,
                path: '/portfolio'
            }, {
                name: 'blog',
                title: 'blog page',
                component: Blog,
                path: '/blog'
            },
            {
                name: 'contact',
                title: 'contact page',
                component: Contact,
                path: '/contact'
            },
        ]
    },
    {
        layout: LayoutTwo,
        routes: [
            {
                name: 'app-Landing',
                title: 'App Landing',
                component: App,
                path: '/app'
            },
        ]
    }
]

export const Routes = renderRoutes(routes);